/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Space_Access_HintInputs */



/**
* | output |
* | --- |
* | "Everyone in the organization includes members who join later. Each person links the space into the projects where they want to use it." |
*
* @param {External_Apis_Space_Access_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_access_hint = /** @type {((inputs?: External_Apis_Space_Access_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Access_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("„Alle in der Organisation“ schließt später hinzukommende Mitglieder ein. Jede Person verknüpft den Space selbst mit den Projekten, in denen sie ihn nutzen möchte.")
	return /** @type {LocalizedString} */ ("Everyone in the organization includes members who join later. Each person links the space into the projects where they want to use it.")
});